import script from "./QuickpaySettingsPaymentPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickpaySettingsPaymentPartners.vue?vue&type=script&setup=true&lang=js"

import "./QuickpaySettingsPaymentPartners.vue?vue&type=style&index=0&id=dc84f24c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc84f24c"]])

export default __exports__